// This file & its store/functions are only necessary if/when we decide to start using shadow DOM custom elements once more; not just a flat API.

import united from "$root/src/united/united.css?inline" assert { type: 'css' };
import sharedStyles from "./ui-core/stores/sharedStyles";

sharedStyles.add(united);

function applyInjectedStylesToShadowRoots() {
	// Apply injected styles to shadow DOMs (e.g. FontAwesome).
	for (const element of document.head.children) {
		if (element instanceof HTMLStyleElement && !!element.textContent) {
			sharedStyles.add(element.textContent);
		}
	}
	queueMicrotask(() => {
		sharedStyles.refresh();
		console.log("refreshing shared styles", sharedStyles.value);
	});
}

export function initStyles() {
	applyInjectedStylesToShadowRoots();
}